import React, { useEffect, useRef, useState } from "react";
import { MuiOtpInput } from "mui-one-time-password-input";
import { FormHelperText } from "@mui/material";
import useKeyboard from "@shared/modules/utils/Keyboard/useKeyboard";
import EventService from "@shared/services/EventService";
import { scrollFieldIntoViewIfHidden } from "@shared/modules/utils/FormField/constants";
import "@app/stylesV2/components/FromField/from_field.scss"

const OtpField2 = React.forwardRef(
    (
        {
            label,
            errorMsg,
            value,
            onChangeInput,
            sizeRange,
            allowedSizes,
            containerClass,
            showKeyboard = true,
            enableScrollFieldIfHiddenEvent = true,
            length,
            virtualKeyboardLayout = "numbersPin",
            virtualKeyboardLang = "en2",
            themeName="numberic",
            ...restProps
        },
        ref
    ) => {
        const [brVal, setBrVal] = useState(true);
        const [fieldfocus, setFocus] = useState(false);
        const userPositionRef = useRef(value.length +1); // 🔑 keeps latest value instantly
        const focusRef = useRef(false); //focus state is "stale" in subscribe event
        const containerRef = useRef(null);

        useEffect(() => {
        if (restProps.forceFocusFirst) {
            const timer = setTimeout(() => {
            const container = containerRef.current;
            if (container) {
                const first = container.querySelector("input");
                first?.focus();
            }
            }, 300);
            return () => clearTimeout(timer);
        }
        }, [restProps.forceFocusFirst]);

        useEffect(() => {
            let eventInput = EventService.subscribe("keypad.blur", bool => {
                setBrVal(bool);
            });
            let eventInput2 = EventService.subscribe("keypad.focus", bool => {
                ref.current?.blur
                setFocus(true);
            });

            let scrollEvent = enableScrollFieldIfHiddenEvent
                ? EventService.subscribe("keyboard.show", () => {
                    if (focusRef.current) {
                        scrollFieldIntoViewIfHidden(ref);
                    }
                })
                : {};

            return () => {
                eventInput.remove();
                eventInput2.remove();
                if (scrollEvent.remove) scrollEvent.remove();
            };
        });

         const handleInputChange = (newValue,bol, userPosition) => {
            
            console.log(userPosition,"userPosition")
            let finalValue = newValue;
            if (typeof userPosition === "number" && userPosition >= 0 && value.length >= userPosition) {
                const isInsert = newValue.length > value.length;
                const isDelete = newValue.length < value.length;

                if (isInsert) {
                    const insertedChar = newValue.slice(-1);
                    finalValue = value.slice(0, userPosition - 1) + insertedChar + value.slice(userPosition);
                } else if (isDelete) {
                    finalValue = value.slice(0, userPosition-1) + value.slice(userPosition);
                }

                console.log({
                    value,
                    newValue,
                    finalValue,
                    isInsert,
                    isDelete
                });
            }
            if (!isValid(finalValue)) return;

            userPositionRef.current =
                newValue.length > value.length
                    ? userPosition + 1
                    : userPosition - 1 >= 1
                    ? userPosition - 1
                    : 1;

            onChangeInput(finalValue);
        };
        const handelBlur = () => {
            if (brVal) {
                EventService.publish("keyboard.hide");
                setFocus(false);
                focusRef.current = false;
            } else {
                setBrVal(true);
                setFocus(true);
                focusRef.current = true;
            }
        };

        const isValid = (inputValue) => {

            if (sizeRange) {
                const max = sizeRange[1];
                if (max !== -1 && String(inputValue).split(".")[0].length > max) {
                return false;
                }
            }

            if (allowedSizes?.length) {
                const largest = Math.max(...allowedSizes);
                if (String(inputValue).length > largest) return false;
            }

            return true;
            };

        const handleInputChangeWrapper = (newValue, bol) => {
            handleInputChange(newValue, bol, userPositionRef.current);
        };

        const { openKeyboard } = useKeyboard(value, handleInputChangeWrapper);

        const setCurrentPosition = (id, val) => {
            if (val) {
                // const output = id.replace(/:r(\d+):/, "$1");
                const newPos = Number(id) + 1;
                console.log("setCurrentPosition triggered with", newPos);
                // Also store in a ref for immediate access
                userPositionRef.current = newPos;
            } else {
                userPositionRef.current = value.length + 1;
            }
        };

       
        return (
            <div
                className={`from-field-amx otp-fields ${errorMsg ? "otp-error-field" : ""} ${fieldfocus ? "blurFocus" : ""} ${
                    containerClass || ""
                }`}
                ref={containerRef}
            >
                <FormHelperText>{label}</FormHelperText>
                <MuiOtpInput
                    inputRef={ref}
                    TextFieldsProps={{
                        inputRef:ref,
                        placeholder: (index) => index===userPositionRef.current -2 ? `|`:"", 
                        onClick:(e)=> {
                            const container = containerRef.current;
                            // find all input fields inside the container
                            const inputs = Array.from(container.querySelectorAll("input"));
                            const target = e.target;
                            const idx = inputs.indexOf(target);
                            setCurrentPosition(idx,e.target.value)
                            }
                    }}
                    label={label}
                    value={value}
                    onChange={e => handleInputChange(e)}
                    length={length}
                    autoFocus={true}
                    onFocus={() => {
                        focusRef.current = true;
                        showKeyboard &&
                        openKeyboard({
                            layoutName: virtualKeyboardLayout || "default",
                            virtualKeyboardLang: virtualKeyboardLang,
                            themeName:themeName
                        })
                    }}
                    variant="outlined"
                    {...restProps}
                    onBlur={handelBlur}
                />
            </div>
        );
    }
);

export default OtpField2;
